/**
 * Default selected period: longest available.
 * @param {number[]} allowedPeriods
 * @returns {number|null}
 */
const getDefaultPeriod = allowedPeriods => {
  if (!Array.isArray(allowedPeriods) || allowedPeriods.length === 0) {
    return null;
  }

  return Math.max(...allowedPeriods);
};

export default getDefaultPeriod;
